import React, { useEffect, useState } from 'react';
import OwnerSidebar from '../../../Components/OwnerSidebar/OwnerSidebar';
import './EventManagementPage.css';
import ownerAPI from '../../../services/ownerApi';
import { useNavigate } from 'react-router-dom';
import EventFormModal from '../../../Components/EventFormModal/EventFormModal';

export default function EventManagementPage() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEvents = async () => {
      const token = localStorage.getItem('ownerToken');
      if (!token) {
        navigate('/owner/login');
        return;
      }

      try {
        const events = await ownerAPI.getEvents();
        setEvents(events);
      } catch (err) {
        console.error('Error fetching events:', err);
        setError('이벤트 목록을 불러오는 데 실패했습니다.');
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, [navigate]);

  const openModal = (event = null) => {
    setSelectedEvent(event);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedEvent(null);
    setIsModalOpen(false);
  };

  const handleEventAdded = (newEvent) => {
    setEvents([...events, newEvent]);
    closeModal();
  };

  const handleEventUpdated = (updatedEvent) => {
    setEvents(events.map(event => event.id === updatedEvent.id ? updatedEvent : event));
    closeModal();
  };

  const handleEventDeleted = async (eventId) => {
    if (window.confirm('정말로 이 이벤트를 삭제하시겠습니까?')) {
      const token = localStorage.getItem('ownerToken');
      try {
        await ownerAPI.deleteEvent(eventId);
        setEvents(events.filter(event => event.id !== eventId));
      } catch (err) {
        console.error('Error deleting event:', err);
        setError('이벤트 삭제에 실패했습니다.');
      }
    }
  };

  return (
    <div className="event-management-wrapper">
      <OwnerSidebar />
      <main className={`event-management-main`}>
        <div className="event-management-header">
          <h1>이벤트 관리</h1>
          <button className="add-event-btn" onClick={() => openModal()}>새 이벤트 추가</button>
        </div>
        <div className="event-list-container">
          {loading ? (
            <p>로딩 중...</p>
          ) : error ? (
            <p className="error-text">{error}</p>
          ) : (
            <table className="events-table">
              <thead>
                <tr>
                  <th>포스터</th>
                  <th>제목</th>
                  <th>설명</th>
                  <th>날짜</th>
                  <th>시간</th>
                  <th>장소</th>
                  <th>장르</th>
                  <th>인스타그램</th>
                  <th>북마크</th>
                  <th>관리</th>
                </tr>
              </thead>
              <tbody>
                {events.map((event) => (
                  <tr key={event.id}>
                    <td>
                      <img src={event.poster_image_url || '/placeholder.png'} alt={event.title} className="poster-thumbnail" />
                    </td>
                    <td>{event.title}</td>
                    <td className="description-cell">
                      <div className="description-preview">
                        {event.description ? 
                          (event.description.length > 50 
                            ? `${event.description.substring(0, 50)}...` 
                            : event.description
                          )
                          : '-'
                        }
                      </div>
                    </td>
                    <td>{event.event_date}</td>
                    <td>
                      {event.start_time && event.end_time 
                        ? `${event.start_time} ~ ${event.end_time}`
                        : event.start_time 
                        ? `${event.start_time} ~`
                        : event.end_time 
                        ? `~ ${event.end_time}`
                        : '-'
                      }
                    </td>
                    <td>
                      {event.club ? event.club.name : (event.location || '-')}
                    </td>
                    <td>{event.genre || '-'}</td>
                    <td>
                      {event.instagram_url ? (
                        <a href={event.instagram_url} target="_blank" rel="noopener noreferrer" className="instagram-link">
                          📷
                        </a>
                      ) : '-'}
                    </td>
                    <td>{event.like_count || 0}</td>
                    <td>
                      <button className="edit-btn" onClick={() => openModal(event)}>수정</button>
                      <button className="delete-btn" onClick={() => handleEventDeleted(event.id)}>삭제</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        {isModalOpen && (
          <EventFormModal
            event={selectedEvent}
            onClose={closeModal}
            onEventAdded={handleEventAdded}
            onEventUpdated={handleEventUpdated}
          />
        )}
      </main>
    </div>
  );
} 